import React, { useEffect } from 'react';
import { Form } from 'antd';
import type { FormInstance } from 'antd';
import type { CSSProperties, ReactNode } from 'react';

interface RecipientValidationFieldProps {
  form: FormInstance;
  selectedRecipients: string[];
  children: ReactNode;
  label?: ReactNode;
  name?: string;
  style?: CSSProperties;
}

const RecipientValidationField: React.FC<RecipientValidationFieldProps> = ({
  form,
  selectedRecipients,
  children,
  label = 'Recipients',
  name = 'recipients_validation',
  style,
}) => {
  useEffect(() => {
    form.setFieldValue(name, selectedRecipients);

    if (selectedRecipients?.length > 0) {
      form.validateFields([name]).catch(() => {});
    }
  }, [selectedRecipients, form, name]);

  return (
    <Form.Item
      name={name}
      label={label}
      required
      rules={[
        {
          validator: async () => {
            if (!selectedRecipients?.length) {
              return Promise.reject(
                new Error('Please select at least one recipient.')
              );
            }
            return Promise.resolve();
          },
        },
      ]}
      style={style}
    >
      <div>{children}</div>
    </Form.Item>
  );
};

export default RecipientValidationField;
